import { authFetch } from './authFetch';

export type IntakeGoal = {
  id: number;
  user: string;
  date: string; // YYYY-MM-DD
  water_goal_ml: number;
  food_goal_g: number;
  created_at: string;
  updated_at: string;
};

export type IntakeProgress = {
  id: number;
  user: string;
  date: string; // YYYY-MM-DD
  water_consumed_ml: number;
  food_consumed_g: number;
  updated_at: string;
};

export async function listGoals(): Promise<IntakeGoal[]> {
  const res = await authFetch('/api/intake-goals/');
  return res.json();
}

export async function upsertGoal(date: string, water_goal_ml: number, food_goal_g: number, id?: number): Promise<IntakeGoal> {
  const body = { date, water_goal_ml, food_goal_g } as any;
  if (id) {
    const res = await authFetch(`/api/intake-goals/${id}/`, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    return res.json();
  }
  const res = await authFetch('/api/intake-goals/', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  return res.json();
}

export async function listProgress(): Promise<IntakeProgress[]> {
  const res = await authFetch('/api/intake-progress/');
  return res.json();
}

export async function upsertProgress(date: string, water_consumed_ml: number, food_consumed_g: number, id?: number): Promise<IntakeProgress> {
  const body = { date, water_consumed_ml, food_consumed_g } as any;
  if (id) {
    const res = await authFetch(`/api/intake-progress/${id}/`, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    return res.json();
  }
  const res = await authFetch('/api/intake-progress/', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  return res.json();
}

